import { types } from "react-bricks/frontend";
import {
  cacheInvalidation,
  enabledForCountries,
  hideFooter,
  hideHeader,
  noIndex,
} from "./_customFields";

export default {
  name: "page",
  pluralName: "Website Pages",
  defaultLocked: false,
  defaultStatus: types.PageStatus.Draft,
  getDefaultContent: () => [],
  customFields: [
    {
      groupName: "Tools",
      defaultOpen: true,
      props: [enabledForCountries(), cacheInvalidation(), noIndex()],
    },
    {
      groupName: "header-footer",
      defaultOpen: false,
      props: [hideHeader(), hideFooter()],
    },
  ],
  categories: [
    {
      category: "Products",
    },
    {
      category: "Features",
    },
    {
      category: "About",
    },
    {
      category: "Contact",
    },
    {
      category: "Home",
    },
    {
      category: "Legal",
    },
    {
      category: "Resources",
    },
    {
      category: "Who we serve",
    },
    {
      category: "Archived",
    },
  ],
} as types.IPageType;
